// extracted by mini-css-extract-plugin
export default {"btnDanger":"Table_btnDanger__+iRAi","btnGreen":"Table_btnGreen__fvM8+","disabled":"Table_disabled__of7ud"};